import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input'
import { SharedFlokModule } from '../../module/shared-flok/shared-flok.module'
import { SharedMemberModule } from '../../module/shared-member/shared-member.module'
import { PublicListingComponent } from './public-listing'
import { PublicListingRoutingModule } from './public-listing-routing.module'
import { WishlistsModule } from "../wishlists/wishlists.module";
import { SearchListingsModule } from '../search-listings/search-listings.module'

@NgModule({
    declarations: [
        PublicListingComponent
    ],
    exports: [
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        PublicListingRoutingModule,
        MatButtonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        SharedFlokModule,
        SharedMemberModule,
        NgxIntlTelInputModule,
        MatInputModule,
        WishlistsModule,
        SearchListingsModule
    ]
})
export class PublicListingModule {}
